export const javascriptType = (type: string):string => {
  let jsType = type || "";
  if (jsType && ['int', 'float', 'double', 'integer'].includes(jsType.toLowerCase())) {
    jsType = 'number';
  }
  return jsType;
}

export const countDecimals = (value) => {
  return Math.floor(value) === value
    ? 0
    : value.toString().split(".")[1].length || 0;
}

export const getStepPrecision = (step) => {
  return countDecimals(parseFloat(String(step)));
}

export const formatCompactNumber = (value: number): string => {
  // @ts-ignore
  return Intl.NumberFormat('en-US', { notation: "compact", compactDisplay: "short" }).format(value);
}

export const objectValues = (obj): any[] => {
  return Object.keys(obj).map((e) => obj[e])
}
